export default __webpack_public_path__ + "static/media/9-21_A.b6699055.svg";